import CarrierRegistrationTypes from './CarrierRegistrationTypes';

export const registerEmailInProgress = (payload) => {
  return {
    payload,
    type: CarrierRegistrationTypes.REGISTER_EMAIL_PROGRESS,
  };
};

export const registerEmailInSuccess = (payload) => {
  return {
    payload,
    type: CarrierRegistrationTypes.REGISTER_EMAIL_SUCCESS,
  };
};

export const registerEmailInError = (payload) => {
  return {
    payload,
    type: CarrierRegistrationTypes.REGISTER_EMAIL_ERROR,
  };
};

export const getRegisterEmailInProgress = (payload) => {
  return {
    payload,
    type: CarrierRegistrationTypes.GET_REGISTER_EMAIL_PROGRESS,
  };
};

export const getRegisterEmailInSuccess = (payload) => {
  return {
    payload,
    type: CarrierRegistrationTypes.GET_REGISTER_EMAIL_SUCCESS,
  };
};

export const getRegisterEmailInError = (payload) => {
  return {
    payload,
    type: CarrierRegistrationTypes.GET_REGISTER_EMAIL_ERROR,
  };
};
export const deactivateRegisterEmailInProgress = (payload) => {
  return {
    payload,
    type: CarrierRegistrationTypes.DEACTIVATE_REGISTER_EMAIL_PROGRESS,
  };
};

export const deactivateRegisterEmailInSuccess = (payload) => {
  return {
    payload,
    type: CarrierRegistrationTypes.DEACTIVATE_REGISTER_EMAIL_SUCCESS,
  };
};

export const deactivateRegisterEmailInError = (payload) => {
  return {
    payload,
    type: CarrierRegistrationTypes.DEACTIVATE_REGISTER_EMAIL_ERROR,
  };
};
